import { jsx as _jsx } from "react/jsx-runtime";
import { Template } from './Template';
import { useViewModel } from './useViewModel';
export const FadeTransitionImage = ({ src, ...passedProps }) => {
    const viewModel = useViewModel(src);
    return _jsx(Template, { ...passedProps, ...viewModel });
};
//# sourceMappingURL=index.js.map